import AnalyticsEvent from './AnalyticsEvent';

abstract class AnalyticsService {
  abstract setUserId(userId: string): void;
  abstract setUserProperties(properties: Record<string, unknown>): void;

  abstract track(
    event: AnalyticsEvent,
    properties?: Record<string, unknown>,
  ): void;

  trackingEvents = Object.keys(AnalyticsEvent)
    .filter(value => !Number.isNaN(Number(value)))
    .map(key => AnalyticsEvent[key as any]);

  shouldTrack(event: AnalyticsEvent) {
    return this.trackingEvents.includes(AnalyticsEvent[event]);
  }
}

export default AnalyticsService;
